
import { Vue, Component, Prop } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import { Button, Tooltip, Card } from 'element-ui';
import BSMinix from '@/views/Home/mixins/bsMixin';
import api from '@/api/course';
import questionApi from '@/api/exam';
import noData from '@/components/noData/index.vue';
import questionModal from '../../../exams/wor/components/questionModal.vue';

@Component({
  components: {
    Draggable,
    Button,
    Tooltip,
    noData,
    Card,
    questionModal,
  },
})
export default class DragWrapper extends Vue {
  private arrs: Array<any> | null = null;

  public $refs!: {
    list: HTMLElement,
  };

  private cid: string = '';

  private disable: {[key: string]: boolean} = {
    save: true,
  };

  private loading: {[key: string]: boolean} = {
    save: false,
  };

  private viewVis: boolean = false; // 控制预览试题模态框

  private questionViewProp: any = {
    contentPD: '', // 正确答案
    questions: '', // 标题
    quesType: '', // 题目类型
    answer: '',
    postForm: [],
  }

  getData(pid: string) {
    this.cid = pid;
    this.disable.save = true;
    return new Promise((resolve, reject) => {
      api.getQlist(pid).then((res: any) => {
        this.arrs = res.map((em: any) => ({
          id: em.question.id,
          knowledge: em.question.knowledge,
          subject: em.question.subject,
          type: em.question.type,
          createAt: em.question.createAt,
          sort: em.sort,
          title: em.question.title,
        })).sort((a: any, b: any) => a.sort - b.sort);
        resolve(this.arrs);
      });
    });
  }

  /**
   * @author Terry
   * @description 删除问题
   * @param { string } id 题id
   * @param { string } title 题目
   */
  handleRemoveQues(id: string, title: string) {
    this.confirm(`你确定要删除 ${title} 吗?`, {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeQuesByCid({ cid: this.cid, qidList: id }).then(() => {
        this.getData(this.cid);
        close();
        this.$log({
          title: '课包详情 - 删除 - 确定',
          component: 'course/chapter/question',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '课包详情 - 删除 - 取消',
      component: 'course/chapter/question',
    }));
  }

  // 拖拽后开启保存按钮
  handleDraggable() {
    this.disable.save = false;
  }

  // 预览试题功能
  questionView(id) {
    questionApi.getQuesDetail(id).then((res: any) => {
      // 预览子组件属性
      this.questionViewProp.questions = res.title;
      this.questionViewProp.answer = res.correct.split(',');
      this.questionViewProp.quesType = res.qstType;
      this.questionViewProp.postForm = res.options;
      if (res.qstType === '0') {
        const Aar = res.correct.split(',');
        for (let i = 0; i < Aar.length; i++) {
          // eslint-disable-next-line no-param-reassign
          for (let j = 0; j < res.options.length; j++) {
            if (res.options[j].prefix === Aar[i]) {
              // eslint-disable-next-line no-param-reassign
              this.questionViewProp.contentPD = res.options[j].content;
            }
          }
        }
      }
      this.viewVis = true;
    });
  }

  handleSave() {
    this.loading.save = true;
    const arrs: any = this.arrs && this.arrs.map((em: any, index: number) => ({
      id: em.id,
      sort: index,
    }));
    /* eslint-disable no-return-assign */
    api.setCourseQuesSort(arrs, this.cid).then((res: any) => {
      this.loading.save = false;
      this.$emit('handleGetData', this.cid);
    }).catch(() => this.loading.save = false);
  }
}
